export const cloudZeroTxt = {
  INCLUDE: "Include ",
  CLOUDZERO_DATA: "CloudZero data",
  TOOLTIP_DESCRIPTION:
    "Include CloudZero cost data in your analytics reports. This data is only available at daily granularity and above. Hourly intervals are not supported.",
};
